import { useNotificationStore } from "../components/Notifications/notification-store";

export interface TDialogResult {
  result: boolean;
  hasError: boolean;
  dialog: Office.Dialog;
  errorMsg: string | null;
}
const makeTDialogResult = (dialog: Office.Dialog, result: boolean, errorMessage?: string | null) => ({
  result: result,
  dialog: dialog,
  hasError: errorMessage != null,
  errorMsg: errorMessage ? errorMessage : null,
});

interface DialogMessage {
  type: string;
}

export const showDialog = async (
  route: string,
  optionsIn?: Office.DialogOptions | undefined
): Promise<TDialogResult> => {
  return new Promise((resolve) => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const url = `${baseUrl}${route}`;

    const options = {
      width: 50,
      height: 50,
      ...optionsIn,
    };

    console.log(`Showing dialog at url: ${url}.`);

    Office.context.ui.displayDialogAsync(url, options, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
          const dialogMessageArg = arg as { message: string; origin: string };
          const dialogMessage = JSON.parse(dialogMessageArg.message) as DialogMessage;
          if (dialogMessage.type === "close") {
            dialog.close();
          }
        });

        resolve(makeTDialogResult(dialog, true));
      } else {
        const errorMsg = `Could not open dialog to route: ${route}. Error: ${result.error.code.toString()} - ${
          result.error.name
        } - ${result.error.message}`;
        console.error(errorMsg);
        useNotificationStore.getState().errorNotification(result.error.name, result.error.code, result.error.message);

        resolve(makeTDialogResult(result.value, false, errorMsg));
      }
    });
  });
};

/**Utility function to help diagnose issues on popups */
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
